export default "__VITE_ASSET__DsZyXxxA__"